import { AgResourceLanguage } from '../types';
import { orderDetails as EnUsOrderDetails } from '../en-us/orderDetails';

export const orderDetails: AgResourceLanguage['orderDetails'] = {
  ...EnUsOrderDetails,
  returnBackButton: 'Volver a Pedidos',
  upcomingOrderDetails: {
    pageTitle: 'Pedido de Suscripción',
    orderDefaultStatus: 'No Pagado',
    orderInformation: {
      orderDateLabel: 'Fecha de Pedido',
      subscriptionNameLabel: 'Suscripción',
      statusLabel: 'Estado',
      totalLabel: 'Total'
    },
    shipNowButton: 'Enviar Ahora',
    skipShipmentButton: 'Omitir Envío',
    changeDateButton: 'Fecha de Pedido',
    subscriptionProductsList: 'Productos de la Suscripción:',
    manageSubscriptionButton: 'Gestionar Suscripción',
    emptyOrders: {
      title: 'Añadidos Únicos',
      description:
        'Compra toda la gama de productos y accesorios AG1, exclusivamente disponible para miembros.',
      buttonName: 'Añadir Producto al Pedido'
    },
    oneTimeField: {
      oneTimeProductsList: 'Añadidos Únicos',
      addProducrToOrderButton: 'Añadir Producto al Pedido',
      oneTimeSubtottal: 'Subtotal de Añadidos Únicos'
    }
  },
  pastOrdersDetails: {
    pageTitle: 'Pedido',
    freeGiftTitle: 'Compartir Paquetes Gratis',
    orderItems: 'Artículos del Pedido',
    trackOrderButton: 'Rastrear Pedido',
    subscriptionNameOTP: 'Compra Única',
    defaultOrderStatus: 'No Disponible',
    orderInformation: {
      orderDateLabel: 'Fecha de Pedido',
      subscriptionNameLabel: 'Suscripción',
      statusLabel: 'Estado',
      totalLabel: 'Total'
    }
  },
  missingValue: 'No Disponible'
};
